module.exports = __webpack_public_path__ + "img/nasolabial_male_narrow.ea23bcc8.png";